// extracted by mini-css-extract-plugin
export default {"buttonGroup":"weatherNavigationComponent_buttonGroup__3lpOg","separte":"weatherNavigationComponent_separte__q57f0"};